import React from "react";
import { useMemo } from "react";
import { useState } from "react";
import stateRegion from "../../state/state.region";
import { observer } from "mobx-react-lite";

const RegionBtn = observer((props) => {
  const [cls, setCls] = useState(false);

  const changeRegion = useMemo(() => {
    const regionID = stateRegion.visibleRegion.find((r) => r === props.region);
       if (regionID) {
      setCls("btn_active_period");
    } else {
      setCls("btn_deactive_period");
    }
  }, [stateRegion.visibleRegion]);

  if (props.btn) {
    return (
      <span onClick={props.onClick} className={cls}>
        {props.region}
      </span>
    );
  } else if (props.badgeV4) {
    return (
      <span className="badge-country-v4" onClick={props.onClick}>
        {props.region}
      </span>
    );
  } else {
    return (
      <span onClick={props.onClick} className="cls_region">
        {props.region}
      </span>
    );
  }
});
export default RegionBtn;
